<template>
    <div
        v-if="introtext"
        :class="{
            'introtext': true,
            [`introtext--${type}`]: true,
        }"
    >
        <div v-if="introtext.subline || introtext.headline" class="introtext__heading">
            <span v-if="introtext.subline" class="introtext__heading-subline" v-html="introtext.subline"></span>
            <span v-if="introtext.headline" class="introtext__heading-headline" v-html="hyphenatedHeadline"></span>
        </div>
        <div v-if="introtext.copytext" class="introtext__text">
            <v-runtime-template :template="`<div>${introtext.copytext}</div>`"></v-runtime-template>
        </div>
        <div v-if="introtext.button || this.$slots['extra-button']" class="introtext__buttons">
            <button-element v-if="introtext.button" :button="introtext.button"></button-element>
            <slot name="extra-button" />
        </div>
        <slot />
    </div>
</template>

<script>
import VRuntimeTemplate from "v-runtime-template/dist/v-runtime-template.es.js";

import ButtonElement from '@/components/elements/ButtonElement.vue';
import hyphenate from '@/common/polyfills/hyphenate';
import { mapGetters } from "vuex";

export default {
    name: 'IntrotextElement',
    components: {
        ButtonElement,
        VRuntimeTemplate,
    },
    props: {
        type: {
            type: String,
            default: () => {
                return 'type-1';
            }
        },
        introtext: {
            type: Object,
            default: () => {
                return {
                    headline: null,
                    subline: null,
                    copytext: null,
                    button: null,
                }
            }
        }
    },
    data() {
        return {
            isLoaded: false
        }
    },
    computed: {
        ...mapGetters('me', {
            me: 'getMe'
        }),

        ...mapGetters('uitexts', {
            t: 't'
        }),

        sehr_geehrte_r() {
            let value = null;

            if (['frau', 'herr'].indexOf(this.me.participantSalutation) !== -1) {
                const key = this.me.participantSalutation == 'frau' ? 'sehr-geehrte' : 'sehr-geehrter';

                value = this.t(key);
            }

            return value;
        },

        liebe_liebe_r() {
            let value = null;

            if (['frau', 'herr'].indexOf(this.me.participantSalutation) !== -1) {
                const key = this.me.participantSalutation == 'frau' ? 'liebe' : 'lieber';

                value = this.t(key);
            }

            return value;
        },

        anrede() {
            return this.t(this.me.participantSalutation);
        },

        titel() {
            return this.me.participantTitle;
        },

        vorname() {
            return this.me.participantFirstName;
        },

        nachname() {
            return this.me.participantLastName;
        },

        geburtstag() {
            return this.me.participantBirthday;
        },

        email() {
            return this.me.participantEMail;
        },

        telefon() {
            return this.me.participantTelephone;
        },

        firma() {
            return this.me.participantCompany;
        },

        abteilung() {
            return this.me.participantDepartment;
        },

        kam() {
            return this.me.participantKAM;
        },

        kategorie() {
            return this.me.participantParticipationCategory;
        },

        position() {
            return this.me.participantParticipationPosition;
        },

        begleitperson() {
            return this.me.participantPlusOne;
        },
    },
    asyncComputed: {
        async hyphenatedHeadline() {
            const text = await hyphenate(this.introtext.headline);
            this.$emit('loaded');
            return text;
        }
    },
    mounted() {

    }
}
</script>
